<section class="home-cta">
  <h2 class="home-cta__title">{{ "UX_TEXT.HOME_CTA.TITLE" | translate }}</h2>
  <p class="home-cta__desc">{{ "UX_TEXT.HOME_CTA.DESC" | translate }}</p>

  <button type="button" class="home-cta__button" (click)="openServices()">
    <ion-icon name="paper-plane"></ion-icon>
    {{ "UX_TEXT.HOME_CTA.BUTTON" | translate }}
  </button>

  <p class="home-cta__foot">
    <ion-icon name="shield-checkmark"></ion-icon>
    {{ "UX_TEXT.HOME_CTA.FOOT" | translate }}
  </p>
</section>
